<div class="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-x-4 md:gap-y-8">
  @for (product of items(); track product.id) {
    <app-product-card
      [name]="isEnglish() ? product.name : product.name_es"
      [category]="isEnglish() ? product.categories[0]?.name : product.categories[0]?.name_es"
      [price]="+product.price"
      [image]="product.image"
      [productId]="product.id"
      [isFavorite]="product.is_favorite"
    />
  }
</div>
